import React from 'react';

type DeleteIconProps = {
  handleDeleteClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function DeleteIcon({
  handleDeleteClick,
  className = 'delete-icon'
}: DeleteIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={handleDeleteClick}
    >
      <path
        d="M8.24903 15.0215C7.84864 15.0215 7.51563 14.7041 7.50098 14.3008L7.25098 7.80078C7.23438 7.38672 7.55762 7.03808 7.97071 7.02246C7.98145 7.02148 7.99122 7.02148 8.00098 7.02148C8.40137 7.02148 8.73438 7.33886 8.74903 7.74218L8.99903 14.2422C9.01563 14.6562 8.69239 15.0049 8.2793 15.0205C8.26856 15.0215 8.25879 15.0215 8.24903 15.0215Z"
        fill="#292929"
      />
      <path
        d="M11.751 15.0215C11.7412 15.0215 11.7314 15.0215 11.7207 15.0205C11.3076 15.0049 10.9844 14.6562 11.001 14.2422L11.251 7.74218C11.2656 7.33886 11.5986 7.02148 11.999 7.02148C12.0088 7.02148 12.0186 7.02148 12.0293 7.02246C12.4424 7.03808 12.7656 7.38672 12.749 7.80078L12.499 14.3008C12.4844 14.7041 12.1514 15.0215 11.751 15.0215Z"
        fill="#292929"
      />
      <path
        d="M17 4H13.5V3.25C13.5 2.00977 12.4902 1 11.25 1H8.75C7.50977 1 6.5 2.00977 6.5 3.25V4H3C2.58594 4 2.25 4.33594 2.25 4.75C2.25 5.16406 2.58594 5.5 3 5.5H3.52002L3.94238 15.8418C3.99023 17.0518 4.97851 18 6.19043 18H13.8096C15.0215 18 16.0098 17.0518 16.0576 15.8418L16.48 5.5H17C17.4141 5.5 17.75 5.16406 17.75 4.75C17.75 4.33594 17.4141 4 17 4ZM8 3.25C8 2.83691 8.33691 2.5 8.75 2.5H11.25C11.6631 2.5 12 2.83691 12 3.25V4H8V3.25ZM14.5596 15.7812C14.543 16.1846 14.2139 16.5 13.8096 16.5H6.19043C5.78613 16.5 5.45703 16.1846 5.44043 15.7812L5.02075 5.5H14.9792L14.5596 15.7812Z"
        fill="#292929"
      />
    </svg>
  );
}

export default DeleteIcon;
